var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLatviaFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contents"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bottom",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9H20V15H0V9Z",
    fill: "var(--fill-0, #C51918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "middle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5H20V8.75H0V5Z",
    fill: "var(--fill-0, #F7FCFF)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "middle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H20V6H0V0Z",
    fill: "var(--fill-0, #C51918)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatviaFlag);
export default __webpack_public_path__ + "static/media/latvia-flag.1b727594b4ef15123e42e32dbf416887.svg";
export { ForwardRef as ReactComponent };